var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNahdi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.49,
    height: 93.136,
    viewBox: "0 0 145.49 93.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-49.063 -63.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M137.252,118.753h-3.424c-.686,0-4.422.244-4.422,5.042v3.982a.154.154,0,0,0,.154.152H133.9v1.081c0,1.161-.159,3.549-3.651,3.549s-3.619-2.388-3.619-3.549v-4.2a.15.15,0,0,0-.1-.142,4.269,4.269,0,0,0-1.578-.3c-1.584,0-1.778,1.022-1.778,1.567v3.852c0,3.5,2.665,5.829,7.093,5.829s7.136-2.2,7.136-5.829v-5.023a.154.154,0,0,0-.154-.154h-4.636s-.005-.5-.005-.882c0-.634.118-1.731,1.3-1.731h3.338a.153.153,0,0,0,.154-.153v-2.93a.153.153,0,0,0-.154-.153",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M191.292,134.313H194.4a.152.152,0,0,0,.152-.154v-19.11a.151.151,0,0,0-.1-.141c-.109-.043-.312-.11-.559-.181a3.121,3.121,0,0,0-.943-.131c-1.656,0-1.817,1.038-1.817,1.6v17.966a.153.153,0,0,0,.154.154",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M187.509,114.785a3.269,3.269,0,0,0-.959-.133c-1.539,0-1.726,1.029-1.726,1.547V127.59c0,2.823-1.348,3.806-3.553,3.806h-3.223a5.678,5.678,0,0,0,.416-.929,8.217,8.217,0,0,0,.411-2.674v-7.432a.148.148,0,0,0-.072-.131,3.461,3.461,0,0,0-1.524-.351,1.932,1.932,0,0,0-1.253.376,1.441,1.441,0,0,0-.473,1.171v6.164c0,3.1-1.722,3.806-3.54,3.806h-2v-6.7a6.408,6.408,0,0,0-.547-2.762c-.362-.764-1.582-3.2-6.833-3.2-.917,0-4.682,0-4.682,2.173a2.11,2.11,0,0,0,.793,1.563.15.15,0,0,0,.193,0,5.93,5.93,0,0,1,3.641-.922c3.829,0,3.968,1.909,3.968,2.646l.006,7.2h-1.617V127.42c0-2.816-3.137-2.933-4.16-2.933s-4.161.128-4.161,2.931v3.976h-3.164v-2.363c0-1.07.085-5.96-7.379-5.96-.92,0-4.683.007-4.683,2.173a2.172,2.172,0,0,0,.791,1.561.148.148,0,0,0,.195,0,6.483,6.483,0,0,1,3.639-.919c2.551,0,3.963.77,3.963,2.644v2.864h-9.692a.152.152,0,0,0-.15.156v2.606a.151.151,0,0,0,.15.153l41.113,0c4.475,0,6.747-2.592,6.747-6.521V115.132a.153.153,0,0,0-.075-.131,3.06,3.06,0,0,0-.563-.216m-25.19,13.076v3.533h-3.078v-3.531c0-1.167,1.373-1.167,1.547-1.167s1.531,0,1.531,1.165",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M178.8,116.274a1.624,1.624,0,1,1-1.624-1.622,1.623,1.623,0,0,1,1.624,1.622",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M135.346,138.522a1.624,1.624,0,1,1-1.625-1.624,1.624,1.624,0,0,1,1.625,1.624",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M128.485,138.522a1.624,1.624,0,1,1-1.626-1.624,1.624,1.624,0,0,1,1.626,1.624",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M146.078,141.406c-.917,0-4.683-.023-4.683,2.171a2.083,2.083,0,0,0,.79,1.563.155.155,0,0,0,.2,0,5.992,5.992,0,0,1,3.639-.918c2.031,0,4.021.489,4.021,2.868a29.921,29.921,0,0,0-3.2-.176c-3.183,0-6.7.56-6.7,4.684,0,4.641,5.686,4.571,7.111,4.571a43.019,43.019,0,0,0,6.083-.443.146.146,0,0,0,.122-.148v-8.21c0-1.072.088-5.962-7.378-5.962m1.173,12.193c-3.4,0-3.7-1.119-3.7-2.031,0-1.366.8-2.164,3.4-2.164a15.63,15.63,0,0,1,3.119.246v3.73a14.872,14.872,0,0,1-2.818.219",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M164.273,141.378a5.528,5.528,0,0,0-4.322,1.569v-5.985a.156.156,0,0,0-.1-.142c-.093-.036-.278-.1-.557-.181a3.348,3.348,0,0,0-.945-.127c-1.637,0-1.814,1.061-1.814,1.6v17.524a.152.152,0,0,0,.152.152H159.8a.152.152,0,0,0,.153-.152v-7.339c0-1.136.378-3.773,3.583-3.773,1.165,0,3.175.125,3.175,3.5v7.61a.153.153,0,0,0,.152.152h3.112a.154.154,0,0,0,.154-.152V147.1c0-5.579-5.005-5.719-5.854-5.719",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M194.457,142.1c-.1-.038-.28-.1-.56-.181a3.222,3.222,0,0,0-.943-.131c-1.661,0-1.817,1.039-1.817,1.6v12.248a.155.155,0,0,0,.154.15h3.11a.152.152,0,0,0,.152-.15V142.241a.149.149,0,0,0-.1-.141",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M130.285,141.406c-6.643,0-7.109,4.838-7.109,5.962v8.266a.152.152,0,0,0,.154.15h3.108a.149.149,0,0,0,.151-.15v-7.473c0-3.827,2.95-3.643,3.7-3.643s3.705-.19,3.705,3.643v7.473a.15.15,0,0,0,.152.15h3.112a.151.151,0,0,0,.153-.15v-8.266c0-2.375-1.37-5.962-7.122-5.962",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M194.471,138.522a1.624,1.624,0,1,1-1.624-1.624,1.623,1.623,0,0,1,1.624,1.624",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M188.011,136.825c-.093-.036-.276-.1-.557-.183a3.369,3.369,0,0,0-.943-.129c-1.631,0-1.791,1.067-1.791,1.6v5.134a6.191,6.191,0,0,0-4.512-1.841,7.075,7.075,0,0,0-7.134,7.382,7.271,7.271,0,0,0,7.543,7.378c1.275,0,7.493-.38,7.493-8.033V136.967a.152.152,0,0,0-.1-.142M184.72,148.78a4.06,4.06,0,1,1-4.056-4.286,4.016,4.016,0,0,1,4.056,4.286",
    fill: "#1d4551"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M70.227,102.528,59.645,113.111l10.582,10.582Z",
    fill: "#e86624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M59.645,91.945,49.063,102.528,59.645,113.11Z",
    fill: "#1b75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M59.645,91.945l10.582,10.582L59.645,113.11Z",
    fill: "#26a6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M70.227,102.528,80.81,113.111,70.227,123.693Z",
    fill: "#f6981f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M49.063,81.363,59.645,91.945,49.063,102.528Z",
    fill: "#822c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M59.645,70.781,49.063,81.363,59.645,91.946Z",
    fill: "#9b2421"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M59.645,70.781,70.227,81.363,59.645,91.946Z",
    fill: "#e92127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M80.81,70.781,70.227,81.363,59.645,70.781Z",
    fill: "#d0dd4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M80.81,70.781l-5.885-5.855h-.014a6.739,6.739,0,0,0-9.366,0h-.018l-5.882,5.855Z",
    fill: "#75be44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M80.81,134.275,70.227,123.693,80.81,113.11Z",
    fill: "#9b2421"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M80.81,134.275l10.582-10.582L80.81,113.11Z",
    fill: "#e92127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M112.556,102.528l10.582,10.583-10.582,10.582Z",
    fill: "#9b2421"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M123.138,91.945l10.583,10.582L123.138,113.11Z",
    fill: "#e86624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M123.138,91.945l-10.582,10.582,10.582,10.583Z",
    fill: "#f6981f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M112.556,102.528l-10.583,10.583,10.583,10.582Z",
    fill: "#e92127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M133.72,81.363,123.139,91.945l10.583,10.583Z",
    fill: "#822c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M123.138,70.781l10.583,10.582L123.138,91.946Z",
    fill: "#1b75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M123.138,70.781,112.557,81.363l10.582,10.583Z",
    fill: "#26a6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M101.974,70.781l10.583,10.582,10.582-10.582Z",
    fill: "#d0dd4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M101.974,70.781l5.885-5.855h.013a6.74,6.74,0,0,1,9.367,0h.017l5.883,5.855Z",
    fill: "#75be44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M101.974,134.275l10.583-10.582L101.974,113.11Z",
    fill: "#1b75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M101.974,134.275,91.392,123.693l10.582-10.583Z",
    fill: "#26a6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M101.974,134.275,91.392,123.693,80.81,134.275Z",
    fill: "#d0dd4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M112.556,81.363,101.974,70.781,91.391,81.363Z",
    fill: "#3d8891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M101.974,134.275l-5.886,5.855h-.012a6.739,6.739,0,0,1-9.366,0h-.018l-5.882-5.855Z",
    fill: "#75be44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M112.556,82.328l9.617,9.617-20.2,20.2-20.2-20.2,9.617-9.617,10.1,10.1.483.482.482-.482,10.1-10.1m0-.965L101.974,91.945,91.392,81.363,80.81,91.945l21.164,21.165,21.164-21.165L112.556,81.363Z",
    fill: "#114652"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNahdi);
export default __webpack_public_path__ + "static/media/nahdi.11ebd7bbc2afd7ebdb3e986783150b09.svg";
export { ForwardRef as ReactComponent };